import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Globe2, Ship, Clock, BarChart3, MapPin } from "lucide-react";
import { activeCountries, glanceStats } from "../mock";

const iconMap = { Globe2, Ship, Clock, BarChart3 };

export default function CountriesModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl" style={{ color: "var(--brand-700)" }}>
            Ruken At A Glance — Detailed Breakdown
          </DialogTitle>
          <DialogDescription>
            A deeper look at our global operations, experience, growth and reach.
          </DialogDescription>
        </DialogHeader>

        {/* 4 metric cards */}
        <div className="grid grid-cols-2 gap-3 mt-2">
          {glanceStats.map((s) => {
            const Icon = iconMap[s.icon] || Globe2;
            return (
              <div key={s.label} className="p-4 rounded-lg border border-border bg-muted/30">
                <Icon size={20} style={{ color: "var(--brand-500)" }} />
                <div className="mt-2 font-display font-bold text-2xl" style={{ color: "var(--brand-700)" }}>
                  {s.prefix || ""}{s.value}{s.suffix || ""}
                </div>
                <div className="text-[11px] uppercase tracking-wider text-muted-foreground mt-0.5">{s.label}</div>
              </div>
            );
          })}
        </div>

        {/* Countries list */}
        <div className="mt-5">
          <h4 className="font-display font-semibold text-sm uppercase tracking-wider mb-3" style={{ color: "var(--brand-700)" }}>
            Our 10 Active Countries
          </h4>
          <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {activeCountries.map((c) => (
              <li key={c} className="flex items-center gap-2.5 px-3 py-2 rounded-lg bg-muted/50 border border-border">
                <MapPin size={13} style={{ color: "var(--brand-500)" }} />
                <span className="text-xs font-medium text-foreground/85">{c}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Highlights */}
        <div className="mt-5 grid sm:grid-cols-3 gap-3 text-xs">
          <div className="p-3.5 rounded-lg border border-border" style={{ background: "var(--brand-50)" }}>
            <p className="font-semibold" style={{ color: "var(--brand-700)" }}>6 Years of Experience</p>
            <p className="mt-1 text-muted-foreground">Operating since 2020 from Dubai, UAE with a large, loyal international client base.</p>
          </div>
          <div className="p-3.5 rounded-lg border border-border" style={{ background: "var(--brand-50)" }}>
            <p className="font-semibold" style={{ color: "var(--brand-700)" }}>4.5M+ Tons Annually</p>
            <p className="mt-1 text-muted-foreground">Bulk industrial raw materials transported across strategic port corridors.</p>
          </div>
          <div className="p-3.5 rounded-lg border border-border" style={{ background: "var(--brand-50)" }}>
            <p className="font-semibold" style={{ color: "var(--brand-700)" }}>8% Annual Growth Rate</p>
            <p className="mt-1 text-muted-foreground">Sustained year-on-year growth through disciplined sourcing and strong partnerships.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
